module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/motorbike-storage-e542faf0cde65fe9a131be2bc21b87ac.png";